export const commentsList = getters => {
  return getters.commentsList
}
